module.exports = __webpack_public_path__ + "static/img/ysgzz.3879d379.png";